import Popup from './popup';
import Tracker from '../../helpers/tracker';
import { TrackingData } from '../../helpers/TrackingTypes';
import { DesignServiceButton } from '../Pdp/DesignServiceButton';
import { GA4BannerTracker } from '../GA4/GA4BannerTracker';

const MoreDetailsPopup = Popup.extend({
	constructor(options) {
		this.config = {
			opener: '[data-lightbox-opener]',
			content: '.modal-content',
			popup: '.modal-window',
			overlay: '.modal-window-overlay',
			designServiceButton: '.js-design-service-btn',
			designServiceModal: '.modal-design-service',
			successPopup: '.modal-design-success-popup',
			pdpButton: '.modal-design-success-popup .js-personalize-button',
			externalLink: '.modal-design-service__linktopage',
			closeBtn: '.modal-window .close-btn, .modal-window .cancel-btn, .modal-design-success-popup .js-close-btn',
			scrollBtn: '.see-details-btn',
		};

		jQuery.extend(true, this.config, options || {});

		this.init();

		this.attachEvents();
	},

	attachEvents() {
		jQuery(document)
			.on('click', this.config.opener, (e) => {
				const currentTarget = jQuery(e.currentTarget);
				if (currentTarget.hasClass('js-custom-option')) {
					let sku = '';

					if (currentTarget.closest('.js-categories-list').length > 0) {
						sku = currentTarget.closest('.js-category-item').attr('data-sku');
					} else {
						sku = productJSON.abstractSku;
					}
					const trackingAction = currentTarget.hasClass('color-item')
						? TrackingData.ACTION_CUSTOM_COLOR_CLICK
						: TrackingData.ACTION_CUSTOM_FORMAT_CLICK;
					Tracker.track({
						category: this.config.trackingCategory,
						action: trackingAction,
						label: sku,
					});
					GA4BannerTracker.trackBannerClick({
						block_section: TrackingData.ACTION_MORE_DETAILS_POP_UP,
						block_index: trackingAction,
						content_name: this.config.trackingCategory,
						content_id: sku,
					});
				}

				e.preventDefault();
				e.stopPropagation();

				const popupContentId = currentTarget.data('lightbox-opener');

				this.open(jQuery(`#${popupContentId}`).html());

				Tracker.track({
					category: this.config.trackingCategory,
					action: currentTarget.data('tracking-action'),
					label: TrackingData.LABEL_LIGHTBOX,
				});
				GA4BannerTracker.trackBannerClick({
					block_section: TrackingData.ACTION_MORE_DETAILS_POP_UP,
					block_index: this.config.trackingCategory,
					content_name: TrackingData.LABEL_LIGHTBOX,
					content_id: currentTarget.data('tracking-action'),
				});
			})
			.on('click', this.config.scrollBtn, (e) => this.smoothScrollToProducts(e))
			.on('click', this.config.designServiceButton, (e) => this.addDesignToBasket(e))
			.on('click', this.config.externalLink, () => this.trackExternalLink())
			.on('click', this.config.closeBtn, () => this.closeDesignPopup());
	},

	trackExternalLink() {
		Tracker.track({
			category: TrackingData.PAGE_PDP,
			action: TrackingData.ACTION_DESIGNSERVICE_GO_TO_SERVICE_LP,
		});
	},

	closeDesignPopup() {
		document.body.classList.remove('is-overlay-open');

		Tracker.track({
			category: TrackingData.PAGE_PDP,
			action: TrackingData.ACTION_DESIGNSERVICE_CLOSE,
		});
	},

	addDesignToBasket() {
		const successPopup = document.querySelector(this.config.successPopup);
		const designServiceModal = document.querySelector(this.config.designServiceModal);
		const modal = document.querySelector(this.config.popup);

		Tracker.track({
			category: TrackingData.PAGE_PDP,
			action: TrackingData.ACTION_DESIGNSERVICE_ADD_TO_BASKET,
		});

		new DesignServiceButton(successPopup, designServiceModal, modal);
	},

	smoothScrollToProducts(e) {
		this.close();

		const destinationPoint = jQuery(jQuery.attr(e.currentTarget, 'data-href'));

		if (!destinationPoint.length) {
			return;
		}

		jQuery('html, body').animate({ scrollTop: destinationPoint.offset().top }, 1000);
	},
});

export default MoreDetailsPopup;
